<template>
  <div class="leftMenuContainer">
    <div class="leftMeau" :class="hideMainSide ? 'hide' : ''">
      <div style="height: 100%; text-align: center">
        <img :src="$appLogo" class="logo" :onerror="`this.src='${$defaultLogo}'`" />
        <navMenu @isshow="isshow"></navMenu>
      </div>
    </div>
  </div>
</template>

<script>
import navMenu from "@/CommonDP/components/navMenu/navMenu";
import globalParams from "@/CommonDP/utils/globalParams";

export default {
  name: "LeftMenu",

  components: {
    navMenu
  },

  data() {
    return {
      hideMainSide: globalParams.get("hideMainSide")
    };
  },

  methods: {
    isshow(item) {
      this.$parent.permissionKey = item.permissionKey;
      if (item.name === "项目") {
        this.$parent.projectType = true;
        this.$parent.$refs.childBreadcrumb.refresh(2);
      } else {
        this.$parent.projectType = false;
      }
      this.$parent.updateProjectType();
    }
  }
};
</script>

<style lang="less" rel="stylesheet/stylus" scoped>
.leftMenuContainer {
  height: 100%;
  .hide {
    display: none;
  }
  .leftMeau {
    width: 68px;
    min-width: 68px;
    height: 100%;
    background: #34495e;
    .logo{
      max-width: 68px;
      padding: 20px 8px;
      object-fit: scale-down;
    }
  }
}
</style>
